import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFlightIcon',
  props: {
  fill: {
    type: String,
    default: "black"
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M21 14.58C21 14.22 20.81 13.89 20.51 13.69L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2.49001 13.69C2.27595 13.8264 2.11855 14.0357 2.04693 14.2792C1.97532 14.5228 1.99434 14.784 2.10047 15.0145C2.20661 15.2451 2.39267 15.4294 2.62424 15.5334C2.8558 15.6374 3.11718 15.6539 3.36001 15.58L10 13.5V19L8.20001 20.35C8.13671 20.3954 8.08542 20.4556 8.05058 20.5253C8.01573 20.595 7.99838 20.6721 8.00001 20.75V21.34C8.00001 21.67 8.32001 21.91 8.64001 21.82L11.5 21L14.36 21.82C14.68 21.91 15 21.67 15 21.34V20.75C15.0016 20.6721 14.9843 20.595 14.9494 20.5253C14.9146 20.4556 14.8633 20.3954 14.8 20.35L13 19V13.5L19.64 15.58C20.32 15.79 21 15.28 21 14.58Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ]))
}
}

})